module.exports = __webpack_public_path__ + "assets/img/cover-check.96de7904.png";